import * as $ from "jquery";
/// <reference path="../../../node_modules/@types/jquery.validation/index.d.ts" />

//import 'slick-carousel';
import { DateTime } from "luxon";
import { showReferrals } from "./enroll";
import { ChooseSchool } from "./chooseschool";
import { getIEVersion } from "./utility";

declare var FlaMap: any;
declare var map_cfg: any;
declare var gtag: any;

$(function () {
    const ieVersion = getIEVersion();

    /* ---- HEADER ---- */
    contextualLinks();
    headLinks();
    nav();
    captureLoginEvent();

    /* ---- BODY ---- */
    breadcrumbMenu();

    if ($(".modal").length > 0) {
        modal();
    }
    if ($("#undergrad-school").length) {
        const cs = new ChooseSchool();
    }
    if ($("#refercode-show").length) {
        showReferrals(); // See enroll.js
    }
    if ($("#eaagree").length) {
        refundPolicy();
    }
    if ($("#BillingInfo").length) {
        payment();
    }
    if ($(".progress.stepper").length) {
        progress(); // See agreement.js
    }
    if ($("div.featured").length && $(".monoRegionCard")) {
        cardShadow();
    }
    if ($(".cards .multiple.featured").length) {
        vicinity();
    }

    /* ---- FOOTER ---- */
    footer();

    /* ---- IE ---- */
    /* if (isIOS()) {
     *     $('body').addClass('ios');
     * }*/

    /* ---- IE ---- */
    if (ieVersion > 0) {
        const version = "ie-" + ieVersion;
        $("body").addClass("ie " + version);
    }
});

function captureLoginEvent() {
    // Gets a reference to the form element, assuming
    // it contains the ID attribute "signup-form".
    const form = <HTMLFormElement> (document.getElementById("formLogin"));

    // Adds a listener for the "submit" event.
    form.addEventListener("submit", function (event) {
        // Monitors whether or not the form has been submitted.
        // This prevents the form from being submitted twice in cases
        // where the event callback function fires normally.
        let formSubmitted = false;

        const submitForm = function () {
            if (!formSubmitted) {
                formSubmitted = true;
                form.submit();
            }
        };

        // Prevents the browser from submitting the form
        // and thus unloading the current page.
        event.preventDefault();

        // Creates a timeout to call submitForm after one second.
        setTimeout(submitForm, 500);

        // Sends the event to Google Analytics and
        // resubmits the form once the hit is done.
        if (gtag) {
            gtag("event", "login", {
                "event_callback": () => {
                    submitForm();
                },
            });
        }
    });
}

/* ---- HEADER ---- */
function headLinks() {
    const $signindd = $("header .signin .dropdown");
    /* Sign In Dropdown */
    $("header .signin").on("click", function (e) {
        e.stopPropagation();
        $signindd.toggleClass("open closed");
        if ($signindd.hasClass("open")) {
            $signindd.find("#sign-in-name").trigger("focus");
        }
    });
    $signindd.on("click", function (e) {
        e.stopPropagation();
    });
    $("body, .extranav .mobile").on("click", function (e) {
        if ($signindd.hasClass("open")) {
            e.preventDefault();
            $signindd.toggleClass("open closed");
        }
    });

    /* Chat */
    $(".utility-group .chat, #click-chat").on("click", function () {
        //SnapEngage.startLink();
    });
}

/* ---- NAV ---- */
function nav() {
    const $nav = $("nav");
    const $navmobile = $nav.find(".mobile");
    const $dropdown = $nav.find(".dropdown");
    $dropdown.wrapInner("<div></div>");
    $dropdown.append(
        '<div class="icon-close"><i class="fa fa-angle-down"></i></div><div class="icon-open"><i class="fa fa-angle-up"></i></div>',
    );

    const $toggleexpand = $dropdown.find(".icon-close,.icon-open");

    $toggleexpand.on("click", function (e) {
        $(this).closest("li").toggleClass("isexpand");
        e.preventDefault(); // kill the link
    });

    // On Click
    $navmobile.on("click", function () {
        toggleNav();
        $("#snapengage-button").toggle();
    });

    $nav.find(".menu-shadow").on("click", function () {
        toggleNav();
    });

    function toggleNav() {
        $nav.toggleClass("open closed");
        $navmobile.toggleClass("item");
    }
}

const URLENROLLLSAT = "/Lsat/Enroll";
const URLENROLLLSATLIVE = "/Register/LsatSelect";
const URLENROLLLSATONLINE = "/Register/LsatOnlineSelect";
const URLENROLLLSATLIVEONLINE = "/Register/LsatLiveOnlineSelect";
const URLENROLLGRE = "/Gre/Enroll";
const URLENROLLGMAT = "/Gmat/Enroll";
const URLENROLLSAT = "/sat/enroll";
const URLENROLLPSAT = "/psat/enroll";
const URLENROLLACT = "/act/enroll";

/* ---- ENROLL ---- */
// A conditional link for course landing pages
function contextualLinks() {
    const pathname = window.location.pathname;
    const pathparts = pathname.split("/");
    const EnrollLinkList = {
        "digital-lsat": URLENROLLLSAT,
        "lsat": URLENROLLLSAT,
        "lsattutoring": URLENROLLLSAT,
        "live-lsat-prep-classes": URLENROLLLSATLIVEONLINE,
        "classroom-lsat-prep-classes": URLENROLLLSATLIVE,
        "lsatadmissionsconsulting": URLENROLLLSAT,
        "lsatprep": URLENROLLLSATLIVE,
        "lsat-course-materials": URLENROLLLSAT,
        "lsat-live-online": URLENROLLLSATLIVEONLINE,
        "lsat-prep-class": URLENROLLLSATLIVE,
        "lsat-prep-class-none": URLENROLLLSAT,
        "lsat-prep-courses": URLENROLLLSAT,
        "lsat-testimonial": URLENROLLLSAT,
        "lsatonline": URLENROLLLSATONLINE,
        "online-lsat-course": URLENROLLLSATONLINE,
        "gre": URLENROLLGRE,
        "greonline": URLENROLLGRE,
        "gre-prep-class": URLENROLLGRE,
        "greabout": URLENROLLGRE,
        "gre-prep-course": URLENROLLGRE,
        "gre-prep-courses": URLENROLLGRE,
        "gmat": URLENROLLGMAT,
        "gmatabout": URLENROLLGMAT,
        "gmatonline": URLENROLLGMAT,
        "gmat-prep-class": URLENROLLGMAT,
        "gmat-prep-course": URLENROLLGMAT,
        "gmat-prep-courses": URLENROLLGMAT,
        "gmattutoring": URLENROLLGMAT,
        "sat": URLENROLLSAT,
        "sat-prep-class": URLENROLLSAT,
        "satabout": URLENROLLSAT,
        "sat-prep-courses": URLENROLLSAT,
        "psat": URLENROLLPSAT,
        "psat-prep-class": URLENROLLPSAT,
        "psatabout": URLENROLLPSAT,
        "psat-prep-courses": URLENROLLPSAT,
        "act": URLENROLLACT,
        "actabout": URLENROLLACT,
        "act-prep-courses": URLENROLLACT,
    };

    if (pathparts.length >= 2) {
        const folder = pathparts[1].toLowerCase();
        const enroll = EnrollLinkList[folder];

        if (enroll) {
            $(".utility-group .enroll a").attr("href", enroll);
        }
    }
}

/* ---- BREADCRUMB MENU ---- */
function breadcrumbMenu() {
    const extranav = $(".extranav .full");
    extranav.addClass("closed");

    $(".extranav").on("click", function (e) {
        e.stopPropagation();
    });
    $(".extranav .mobile").on("click", function (e) {
        extranav.toggleClass("open closed");
        $(".extranav .mobile i").toggle();
    });
    $("body, header .signin > .fa-user, header .signin > span").on(
        "click",
        function (e) {
            if (extranav.hasClass("open")) {
                e.preventDefault();
                extranav.toggleClass("open closed");
                $(".extranav .mobile i").toggle();
            }
        },
    );
}

/* ---- ieGrid ---- */
function ieGrid() {
    if ($(".grid .sidebar").length) {
        $(".grid").addClass("with-sidebar");
    }
    $(".grid").addClass("ie");
}

/* ---- SLIDER ---- */
export function lsatSlider() {
    (<any> $(".lsat-slider")).slick({
        autoplay: true,
        autoplaySpeed: 7500,
        pauseOnHover: false,
        pauseOnFocus: false,
        dots: false,
        arrows: true,
        useTransform: false,
        prevArrow: '<i class="arrow prev fa fa-icon fa-caret-left"></i>',
        nextArrow: '<i class="arrow next fa fa-icon fa-caret-right"></i>',
    }).show();
}

export function facultySlider() {
    (<any> $(".slider-list")).slick({
        autoplay: true,
        autoplaySpeed: 7500,
        pauseOnHover: false,
        pauseOnFocus: false,
        dots: false,
        arrows: true,
        useTransform: false,
        prevArrow: '<i class="arrow prev fa fa-icon fa-caret-left"></i>',
        nextArrow: '<i class="arrow next fa fa-icon fa-caret-right"></i>',
    }).show();
}

let isWatching = false;

function watchModalClose() {
    if (!isWatching) {
        /* Close modal when the mask or "x" icon are clicked */
        $(".modal .mask, .modal .fa-times").on("click", function () {
            $(this).closest(".modal").fadeOut(100);
        });
        isWatching = true;
    }
}

// Launch a given modal
export function launchModal($modal: JQuery) {
    const ieVersion = getIEVersion();
    $modal.fadeToggle(100);
    $modal.css("display", "flex");

    if (ieVersion > 0) {
        $modal.css("display", "block");
        $modal.find(".mask").css("filter", "Alpha(Opacity=50)");
    }

    watchModalClose();
}

/* ---- MODALS ---- */
function modal() {
    $(".modal-trigger:not(#instructor-button)").on("click", function () {
        const modalid = "#" + $(this).attr("id");
        if (modalid) {
            const modal = modalid.replace("button", "modal");
            const $modal = $(modal);

            launchModal($modal);
        }
    });
}

/* ---- DATE PICKER USED FOR NON-LSAT ONLINE CLASSES ---- */
export function dateSelect(minDate: Date, courseDays: number) {
    const $start = $("#DateBegin");
    const $end = $(".end-date .date");
    const STDFORMAT = "MM/dd/yyyy";
    const lMinDate = DateTime.fromJSDate(minDate);

    (<any> $start).datepicker({
        minDate: minDate,
        onSelect: updateDate,
    }).change(updateDate);

    updateDate();

    function updateDate() {
        let startTime = DateTime.fromFormat(<string> $start.val(), STDFORMAT);
        if (startTime < lMinDate) {
            startTime = lMinDate;
            $start.val(startTime.toFormat(STDFORMAT));
        }

        if (courseDays) {
            // Single-date option
            const endTime2 = startTime.plus({ days: courseDays });
            $end.html(endTime2.toFormat(STDFORMAT));
        } else {
            // Multi-date option
            const $rows = $("#multi-date tr");
            $rows.each(function () {
                const $row = $(this);
                const $option = $row.find(".name");
                const length = (<string> $option.text()).replace("months", "")
                    .trim();
                const months = parseInt(length);
                const endTime = startTime.plus({ months: months }).toFormat(
                    STDFORMAT,
                );
                const $target = $row.find(".enddate");
                $target.text(endTime);
            });
            $(".hiddendates").val(<string>$start.val());
        }
    }
}

/* ---- VICINITY ---- */
function vicinity() {
    $(".dateline").on("click", function () {
        const index = <string> $(this).data("index");
        $("table.monoRegionOuterTable").removeClass("center");
        $(".featured").hide();
        $("#featured" + index).css("display", "flex");
    });
    $(".close").on("click", function () {
        $("table.monoRegionOuterTable").addClass("center");
        $(".featured").hide();
    });
}

/* ---- CARDS ---- */
function cardShadow() {
    const location = $(".featured #vicinity").text().replace(/^\s+|\s+$/g, "");
    const color = $(".featured #vicinity").css("background-color");
    const rgba = color.replace(/rgb/i, "rgba").replace(/\)/i, ",0.25)");

    $(".monoRegionHead:contains(" + location + ")").parent().parent().css(
        "background",
        rgba,
    );
}

/* ---- REFUND POLICY ---- */
function refundPolicy() {
    $("#eaagree").on("click", function () {
        $(".eacheckerror").hide();
    });
    $("form").on("submit", function () {
        if ($("#eaagree:checked").length > 0) {
            return true;
        } else {
            $(".eacheckerror").show();
            return false;
        }
    });
}

/* ---- PAYMENT ---- */
function payment() {
    // Card Validation
    const cc = $("#CardNumber");
    const error = "input-validation-error";
    const submit = $('input[type="submit"]');

    submit.on("click", function (e) {
        if (!cc.validate().valid) {
            e.preventDefault();
            cc.addClass(error);
        } else {
            submit.removeAttr("disabled");
        }
    });

    // Billing Info
    const diffAddress = $("#ShippingBillingAddressDifferent");
    const billingInfo = $("#BillingInfo:not(.visible)");
    if (diffAddress.is(":checked")) {
        billingInfo.show();
    } else {
        billingInfo.hide();
    }
    diffAddress.on("click", function () {
        if (diffAddress.is(":checked")) {
            billingInfo.slideDown("fast");
        } else {
            billingInfo.slideUp("fast");
        }
    });
}

/* ---- PROGRESS ---- */
function progress() {
    const active = $(".progress.stepper").parent().attr("class");
    const steps = $(".progress.stepper .steps > div");
    let target: number;

    switch (active) {
        case "first":
            target = 1;
            break;
        case "second":
            target = 2;
            break;
        case "third":
            target = 3;
            break;
        case "fourth":
            target = 4;
            break;
        case "fifth":
            target = 5;
            break;
        case "sixth":
            target = 6;
            break;
    }

    steps.each(function (i) {
        if (i == target - 1) {
            const $step = $(this);
            $step.find(".navy.square").toggleClass("navy orange");
        }
    });
}

/* ---- MAP ---- */
export function map() {
    // Get map data
    const map_data = map_cfg.map_data;
    for (var statedata in map_data) {
        if (map_data.hasOwnProperty(statedata)) {
            map_data[statedata].link = "state?state=" +
                encodeURIComponent(map_data[statedata].code);
        }
    }

    // Draw map
    const map = new FlaMap(map_cfg);
    map.drawOnDomReady("mymap");

    // Redirect on map click
    map.on("click", function (ev, sid, themap) {
        if (sid == "p0") {
            window.location.href = "state?state=DC";
        } else {
            const statecode = map.fetchStateAttr(sid, "code");
            window.location.href = "state?state=" +
                encodeURIComponent(statecode);
        }
    });

    // Redirect on dropdown selection
    $("#statelist,#countrylist").on("change", function () {
        const state = <string> $(this).val();
        if (state) {
            const states = state.split(",");
            if (states.length == 1) {
                window.location.href = "state?state=" +
                    encodeURIComponent(states[0]);
            } else {
                window.location.href = "state?state=" +
                    encodeURIComponent(states[0]) + "&city=" +
                    encodeURIComponent(states[1]);
            }
        }
    });

    (<HTMLSelectElement> ($("#statelist")[0])).selectedIndex = 0;
    (<HTMLSelectElement> ($("#countrylist")[0])).selectedIndex = 0;
}

/* ---- FOOTER ---- */
function footer() {
    const $footer = $("footer .section");
    $footer.addClass("closed");
    $footer.on("click", function () {
        $(this).toggleClass("open closed");
    });
}
